import React from 'react';
import Lottie from 'react-lottie';

import animationData from '../assets/lottie/loading.json';

const LoadingAnimation = () => {
  const defaultOptions = {
    animationData,
    autoplay: true,
    loop: true,
    rendererSettings: { preserveAspectRatio: 'xMidYMid slice' },
  };
  return <Lottie options={defaultOptions} height={120} width={120} />;
};

export default LoadingAnimation;
